// extracted by mini-css-extract-plugin
module.exports = {"layout":"aee5b7c44e--layout--TjvSZ","spinner":"aee5b7c44e--spinner--uIpxO","container":"aee5b7c44e--container--O_TQ1","error":"aee5b7c44e--error--bfnyQ"};